import { render, staticRenderFns } from "./FeedsForm.vue?vue&type=template&id=f67d7ce4"
import script from "./FeedsForm.vue?vue&type=script&lang=js"
export * from "./FeedsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports